<template>
  <div class="padding-main d-flex flex-column align-items-center">
    <h2 class="mb-5 mt-3">Leggyakoribb Termékek</h2>
    <br/>
    <div class="d-flex justify-content-around product-container">
      <SideCardContainer
      title="Redőnyök" 
      :items='items[0]'
    >
      <CarouselContainer id="redony">
        <div class="carousel-item active">
          <CdnImage 
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/plastic-shutter" 
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/shutter_1.jpg"
            alt="Veszprém redőny javítás" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Osztott műanyag redőny</h5>
          </div>
        </div>
        <div class="carousel-item">
          <CdnImage 
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/alu-shutter" 
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/shutter_2.jpg"
            alt="Redőny Veszprém" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Látszó tokos alumínium redőny</h5>
          </div>
        </div>
        <div class="carousel-item">
          <CdnImage
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/hidden-shutter"
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/shutter_3.jpg"
            alt="Redőny javítás Veszprém" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Vakolható tokos redőny</h5>
          </div>
        </div>
      </CarouselContainer>
    </SideCardContainer>
    <SideCardContainer
      title="Szúnyoghálók" 
      :items='items[1]' 
    >
    <CarouselContainer id="szunyoghalo">
        <div class="carousel-item active">
          <CdnImage
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/fix-net"
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/net_0.jpg"
            alt="Szúnyogháló Veszprém" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Peremes Fix Szúnyogháló</h5>
          </div>
        </div>
        <div class="carousel-item">
          <CdnImage
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/rolling-net"
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/net_1.jpg"
            alt="Veszprém szúnyogháló" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Vízszintes mozgatású rolós Szúnyogháló</h5>
          </div>
        </div>
        <div class="carousel-item">
          <CdnImage
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/door-net"
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/net_2.jpg"
            alt="Veszprém szúnyogháló beépítés" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Nyíló Szúnyogháló Atjó</h5>
          </div>
        </div>
        <div class="carousel-item">
          <CdnImage
            src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/plise"
            classes="d-block w-100"
            fallbackSrc="./static/assets/products/net_3.jpg"
            alt="Veszprém árnyékolás" />
          <div class="carousel-caption d-none d-md-block">
            <h5>Pliszé</h5>
          </div>
        </div>
      </CarouselContainer>
    </SideCardContainer>
    </div>
    <div class="d-flex justify-content-around product-container mt-5">
      <SideCardContainer
        title="Belső Árnyékolók" 
        :items='items[2]'
      >
        <CarouselContainer id="belso">
          <div class="carousel-item active">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/reluxa"
              classes="d-block w-100"
              fallbackSrc="./static/assets/products/int_1.jpg"
              alt="Veszprém reluxa beszerelés" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Reluxa</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/roller" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/int_2.jpg"
              alt="Veszprém roletta beszerelés" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Roletta</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/plise-shader" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/int_3.jpg"
              alt="Pliszé Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Pliszé Árnyékoló</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/string-courtain" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/int_4.jpg"
              alt="Szalagfüggöny Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Szalagfüggöny</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/roof-roller" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/int_5.jpg"
              alt="Tetőtér árnyékolás Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Tetőtéri Roló</h5>
            </div>
          </div>
        </CarouselContainer>
      </SideCardContainer>
      <SideCardContainer
        title="Külső Árnyékolók" 
        :items='items[3]'
        >
        <CarouselContainer id="kulso">
          <div class="carousel-item active">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/sun-shader" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/ext_1.jpg"
              alt="Napellenző Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Napellenző</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/garage-shutter" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/ext_2.jpg"
              alt="Redőnykapu kivitelezés Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Redőnykapu</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/yard-shader" 
              classes="d-block w-100"
              fallbackSrc="./static/assets/products/ext_3.jpg" 
              alt="Télikert árnyékolás Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Télikert Árnyékoló</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/pergola" 
              classes="d-block w-100" 
              fallbackSrc="./static/assets/products/ext_4.jpg"
              alt="Pergola Veszprém" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Ponyvás Pergola</h5>
            </div>
          </div>
          <div class="carousel-item">
            <CdnImage 
              src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/v1/products/screen" 
              classes="d-block w-100"
              fallbackSrc="./static/assets/products/ext_5.jpg"
              alt="Veszprém Árnyékolás" />
            <div class="carousel-caption d-none d-md-block">
              <h5>Napháló</h5>
            </div>
          </div>
        </CarouselContainer>
      </SideCardContainer>
    </div>

    <ContactUsSection />
  </div>
</template>

<script>
import SideCardContainer from '@/components/SideCardContainer.vue';
import CarouselContainer from '@/components/CarouselContainer.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import CdnImage from '@/components/CdnImage.vue';

export default {
  name: "MenuPage",
  data() {
    return {
      majorVersion: 1,
      minorVersion: 1,
      items: [
        [ 'műanyag', 'alumínium (motorizálható)', 'vakolható'],
        ['fix (műanyag, alumínium többféle kivitelben)', 'rolós (mozgatható)', 'ajtók (nyíló, eltolható)', 'pliszé'],
        ['reluxa', 'roletta', 'pliszé árnyékoló', 'szalagfüggöny', 'tetőtéri roló'],
        ['napellenző', 'redőnykapu', 'télikert árnyékoló', 'pergola', 'napháló']
      ]
    };
  },
  components: {
    SideCardContainer,
    CarouselContainer,
    ContactUsSection,
    CdnImage,
  }
}
</script>

<style lang="scss">
@use '../assets/style/variables';
.padding-main {
  padding-top: 75px;
}

.menu-image {
  width: 80%;
  padding-top: 50px;
  padding-bottom: 50px;
}

.product-container {
  width: 90%;
}

@media screen and (max-width: 800px) {
  .product-container {
    width: 90%;
    flex-direction: column !important;
    align-items: center !important;
  }
}
</style>